import { render, staticRenderFns } from "./Credential.vue?vue&type=template&id=d45fe484&scoped=true"
import script from "./Credential.vue?vue&type=script&lang=js"
export * from "./Credential.vue?vue&type=script&lang=js"
import style0 from "./Credential.vue?vue&type=style&index=0&id=d45fe484&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45fe484",
  null
  
)

export default component.exports